import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import App from './App';
import './index.css';
import './lib/i18n';

// Phase 4: Sentry — only in production
if (import.meta.env.PROD && import.meta.env['VITE_SENTRY_DSN']) {
  import('@sentry/react').then(({ init }) => {
    init({
      dsn: import.meta.env['VITE_SENTRY_DSN'] as string,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.1,
      integrations: [],
      beforeSend(event) {
        // Strip PII — auth tokens and cookies must never reach Sentry
        if (event.request?.headers) {
          delete event.request.headers['authorization'];
          delete event.request.headers['cookie'];
        }
        if (event.breadcrumbs) {
          // Sentry v10: breadcrumbs is Breadcrumb[] directly
          for (const crumb of event.breadcrumbs) {
            if (crumb.data?.['Authorization']) delete crumb.data['Authorization'];
            if (crumb.data?.['authorization']) delete crumb.data['authorization'];
            if (crumb.data?.['cookie']) delete crumb.data['cookie'];
          }
        }
        return event;
      },
    });
  }).catch(() => {
    // Sentry init failure is non-fatal
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
